import { Controller } from '@hotwired/stimulus'
import { trackAmplitudeEvent } from '../../../analytics/CustomEvents'

export default class extends Controller {
  static targets = ['query']

  track () {
    const query = this.queryTarget.value.trim()
    if (!query) return

    trackAmplitudeEvent('Visual Discovery Search Clicked', { query })
  }
}
